import React from 'react';
import { Form } from '../../../components/form/Form';
import { useFormSubmit } from '../../../controllers/useSubmitForm';

export const TechnicalLeadForm = props => {
  const {route: {params} = {}, headerTitle} = props;
  const {row} = params;
  let {onSubmit} = useFormSubmit({
    uri: '/employeeassociations',
    eventSourceId: 'employeeassociation',
  });
  return (
    <Form
      header={{
        title: headerTitle,
        secondaryTitle: `${row?.name}`,
      }}
      defaultValues={{
        employee: row?._id,
        // type: 'Skill Leader',
      }}
      api={`/employeeassociations/${row?._id}`}
      onSubmit={onSubmit}
      submitAction="Save"
      layoutFields={[
        {
          placeholder: 'Technical lead',
          label: 'Technical lead',
          field: 'skill_leader',
          type: 'autoComplete',
          api: `/employeeSuggestions`,
          suggestionField: 'name',
          valueField: 'name',
          secondarySuggestionField: 'official_email_id',
          required: true,
        },
        {
          label: 'Start Date',
          type: 'date',
          field: 'from_date',
          required: true,
          size: 6,
        },
        {
          label: 'End Date',
          type: 'date',
          field: 'to_date',
          size: 6,
        },
      ]}
      {...props}
    />
  );
};

export const AddTechnicalLeadForm = props => {
  return <TechnicalLeadForm headerTitle="Technical lead" {...props} />;
};

export const EditTechnicalLeadForm = props => {
  return (
    <TechnicalLeadForm
      mode="edit"
      headerTitle={'Update Technical lead'}
      {...props}
    />
  );
};
